import { ReactNode } from 'react';

import { Text } from '#atoms';

const PortfolioTitleWrap = ({
  title,
  children,
  fontSize = '1.6rem',
  color = '#C9C7D1',
  gap = '8',
  rightContent
}: {
  title: string;
  children?: ReactNode;
  fontSize?: string;
  color?: string;
  gap?: string;
  rightContent?: ReactNode;
}) => {
  return (
    <div className={`flex flex-col gap-${gap}`}>
      <div className="flex justify-between items-center w-full">
        <Text style={{ fontSize: fontSize, color: color }}>{title}</Text>
        {rightContent}
      </div>
      <div className="flex flex-col gap-12">{children}</div>
    </div>
  );
};

export default PortfolioTitleWrap;
